/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorWorkspaceUserDto } from '../../models/vendor-workspace-user-dto';

export interface VendorWorkspaceUserControllerFindUserById$Params {

/**
 * 멤버 ID
 */
  userId: string;

/**
 * 입점사 ID
 */
  id: any;
}

export function vendorWorkspaceUserControllerFindUserById(http: HttpClient, rootUrl: string, params: VendorWorkspaceUserControllerFindUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceUserDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceUserControllerFindUserById.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceUserDto>;
    })
  );
}

vendorWorkspaceUserControllerFindUserById.PATH = '/api/vendorWorkspaceUser/{id}/users/{userId}';
